import { useEffect, useState } from 'react';
import api from './api';

// Limite de upload por arquivo. A fonte é MAX_UPLOAD_MB no backend/.env
// (GET /api/config/upload). Buscado uma vez e compartilhado por todas as telas.
const PADRAO_MB = 25;
let cacheMb = null;
let pedido = null;

export function carregarLimiteUpload() {
  if (cacheMb) return Promise.resolve(cacheMb);
  if (!pedido) {
    pedido = api.get('/config/upload')
      .then((r) => { cacheMb = Number(r.data?.max_upload_mb) || PADRAO_MB; return cacheMb; })
      .catch(() => { pedido = null; return PADRAO_MB; });
  }
  return pedido;
}

/** Hook: retorna { mb, bytes } do limite atual. */
export function useLimiteUpload() {
  const [mb, setMb] = useState(cacheMb || PADRAO_MB);
  useEffect(() => { let vivo = true; carregarLimiteUpload().then((v) => vivo && setMb(v)); return () => { vivo = false; }; }, []);
  return { mb, bytes: mb * 1024 * 1024 };
}
